import quickFetch from 'quick-fetch';
export function getEarlyRequest(requestKey) {
  return quickFetch.getRequestStateByName(requestKey);
}
export function getEarlyRequesterResultPromise({
  name,
  retryRequest
}) {
  const earlyMetaRequest = getEarlyRequest(name);
  if (!earlyMetaRequest) {
    return retryRequest();
  }
  return new Promise((resolve, reject) => {
    earlyMetaRequest.whenFinished(result => {
      resolve(result);
      quickFetch.removeEarlyRequest(name);
    });
    earlyMetaRequest.onError(() => {
      retryRequest().then(resolve, reject).catch(reject);
      quickFetch.removeEarlyRequest(name);
    });
  });
}